module.exports = __webpack_public_path__ + "static/wawa_logo_color_final-fffa44452c062b8c94ed02634fa539bd.png";